import { mediaSupportService } from 'affiny-core/services/MediaSupportStrategy';
import merge from 'lodash/merge';
import {
  FetchLike,
  Middleware,
  WretcherOptions,
  WretcherResponse,
} from 'wretch';

export const picturesMiddleware: Middleware = () => (next: FetchLike) => async (
  url: string,
  opts: WretcherOptions
): Promise<WretcherResponse> => {
  if (opts.method === 'GET') {
    return mediaSupportService.getAcceptHeader().then(acceptedFormat =>
      next(
        url,
        merge(opts, {
          headers: { Accept: `${acceptedFormat}` },
        })
      )
    );
  }

  return next(url, opts);
};
